import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import {
    Button
} from 'reactstrap';

// Components
import UserForm from './UserForm';
import Notifications from '../Notifications';

// images
import save from '../../images/save.svg';
import leftChevron from '../../images/left-chevron.svg';

// services
import AuthService from '../../services/AuthService';
import UserService from '../../services/UserService';

// actions
import { set_header } from '../../actions/header';

function AddUserPage({ set_header }) {
    const navigate = useNavigate();

    const formValidation = (user, dealers) => {
        const validEmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        
        if (user['email'] === "") {
            return false;
        } else if (!user['email'].match(validEmailRegex)) {
            return false;
        } else if (user['name'] === "") {
            return false;
        } else if (user['surname'] === "") {
            return false;
        } else if (user['role'] === null || user['role'] === undefined) {
            return false;
        } else if (dealers.length === 0) {
            return false
        }
        return true;
    }

    const onSubmit = async (user, dealers) => {

        if (formValidation(user, dealers)) {
            try {
                let newUser = await UserService.createUser(user)
                console.log(newUser)
                if (newUser.statusCode === 200) {
                    const userPayload = {
                        userId: newUser.data.user.id,
                        dealerIds: dealers
                    }
                    let dealerAssignedUser = await UserService.linkDealerToUser(userPayload)
                    if (dealerAssignedUser.statusCode == 200) {
                        Notifications("success", "Setup email has been sent to the user.")
                        navigate('/users')
                    } else {
                        Notifications('error', 'Failed to assign dealers.')
                    }
                } else {
                    Notifications('Failed to create user.')
                }
            } catch (e) {
                Notifications('error', e['message'])
            }
        }
    };

    useEffect(() => {
        set_header('Users', 'NEW')
    }, [set_header]);

    return (
        <React.Fragment>
            <div className="content">
                <div className="content-row">
                    <div className='details-page__header'>
                        <div className='vertical-align-div'>
                            <Link to='/users'>
                                <Button>
                                    <img src={leftChevron} alt="Back"/>
                                </Button>
                            </Link>
                        </div>
                        <div className='details-page__menu'>
                            <button 
                                className='filter-buttons active'
                            >
                                Info
                            </button>
                        </div>
                    </div>
                </div>
                <div className="content-row flex-grow">
                    <UserForm 
                        onSubmit={onSubmit}
                        adding={true}
                    />
                </div>
                <div className="content-row footer">
                    <Link to='/users'>
                        <Button
                            className="footer__cancel-button"
                        >
                            <div className="vertical-align-div">
                                <span>Cancel</span>
                            </div>
                        </Button>
                    </Link>
                    <Button
                        className="footer__save-button"
                        form='user-form'
                        type='submit'
                    >
                        <div className="vertical-align-div">
                            <span>Save Info</span>
                        </div>
                        <div className="vertical-align-div">
                            <img src={save} alt="Save"/>
                        </div>
                    </Button>
                </div>
            </div>
        </React.Fragment>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        set_header: (main, sub) => dispatch(set_header(main, sub))
   };
};

export default connect(null, mapDispatchToProps)(AddUserPage);